import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "booking-event-tooltip" }
const _hoisted_2 = { class: "reservation-number" }
const _hoisted_3 = { class: "staff-name" }
const _hoisted_4 = { class: "staff-name" }
const _hoisted_5 = { class: "reservation-time" }
const _hoisted_6 = { class: "menu-name" }
const _hoisted_7 = { class: "price" }
const _hoisted_8 = {
  key: 0,
  class: "order-price"
}
const _hoisted_9 = { class: "staff-name" }
const _hoisted_10 = { class: "staff-name" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "medical-options" }, "オプションメニュー:", -1)
const _hoisted_12 = { class: "note" }

import { withDefaults, computed } from "vue";
import { get } from "@vueuse/core";
import TimeUtils from "@/clinic/utils/time-utils";
import NumberUtils from "@/clinic/utils/number-utils";
import { Dictionary, EventImpl } from "@fullcalendar/core/internal";

type IEventType = {
  event: EventImpl;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'tooltip',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as { event: EventImpl };



const extendedProps = computed((): Dictionary => props.event.extendedProps);

const rangeTime = computed((): string => {
  const { start, end } = props.event;
  if (!start || !end) return "";

  return TimeUtils.formatRangeDateTime(start, end);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "予約番号 : " + _toDisplayString(_unref(get)(_unref(extendedProps)).reservationId), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(get)(_unref(extendedProps)).customerName) + " 様", 1),
    _createElementVNode("p", _hoisted_4, "フリガナ: " + _toDisplayString(_unref(get)(_unref(extendedProps)).customerNameKana), 1),
    _createElementVNode("p", _hoisted_5, " 予約日: " + _toDisplayString(_unref(get)(_unref(rangeTime))), 1),
    _createElementVNode("p", _hoisted_6, "メニュー名: " + _toDisplayString(_unref(get)(_unref(extendedProps)).medicalMenuName), 1),
    _createElementVNode("p", _hoisted_7, " 金額： " + _toDisplayString(_unref(NumberUtils).formatJPCurrency(parseInt(_unref(get)(_unref(extendedProps)).bookingTotalAmount), "")) + "円 ", 1),
    (_unref(get)(_unref(extendedProps)).additionalFees)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 指名料： " + _toDisplayString(_unref(NumberUtils).formatJPCurrency(parseInt(_unref(get)(_unref(extendedProps)).additionalFees.nomination_fee), "")) + "円 ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_9, "担当施術者: " + _toDisplayString(_unref(get)(_unref(extendedProps)).staff.name_kanji), 1),
    _createElementVNode("p", _hoisted_10, "部屋・設備予約: " + _toDisplayString(_unref(get)(_unref(extendedProps)).room?.name), 1),
    _hoisted_11,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(get)(_unref(extendedProps)).medicalOptionNames, (optionName, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("p", null, _toDisplayString(optionName), 1)
      ]))
    }), 128)),
    _createElementVNode("span", _hoisted_12, "予約メモ : " + _toDisplayString(_unref(get)(_unref(extendedProps)).note), 1)
  ]))
}
}

})